<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      创建交货单<span v-if="purchaseOrders.length === 1" class="modal-secondary-title">{{purchaseOrders[0].code}}</span>
      <gj-tag
          type="plain"
          shape="rectangle"
          style="margin-left: 8px;"
          :color="purchaseOrders[0].status | optionColor(PurchaseOrderEnum.statusOption)">
        {{ purchaseOrders[0].status | optionText(PurchaseOrderEnum.statusOption) }}
      </gj-tag>
    </template>
    <template #content>
      <div v-if="false">
        <gj-input v-model="labelWidth" />
        <gj-input v-model="label1Width" />
      </div>
      <el-form
          ref="form"
          :model="form"
          :label-width="labelWidth">
        <gj-area-title>基本信息</gj-area-title>
        <el-row>
          <el-col :span="6">
              <el-form-item
                  label="供应商"
                  prop="name"
                  :label-width="label1Width">
                <gj-text width="100%">{{purchaseOrders[0].supplierName | defaultShow}}</gj-text>
              </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="运费"
                prop="transportFee.value"
                :label-width="label1Width"
                :rules="[
                  $gjReRule(RE.num(2), '最多两位小数的正数'),
                  $gjMinRule(0.02, '应大于等于0.02'),
                ]">
                <gj-select-input
                  v-model="form.transportFee"
                  @input="transportFeeInput"
                  :options="[
                      {id: 'CNY', text: 'CNY'},
                      {id: 'USD', text: 'USD'}
                  ]"
                  :width="['85px', '100px']"
                ></gj-select-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="其他费用"
                prop="otherFee.value"
                :label-width="label1Width"
                :rules="[
                  $gjReRule(RE.num(2), '最多两位小数的正数'),
                  $gjMinRule(0.02, '应大于等于0.02'),
                ]">
                <gj-select-input
                  v-model="form.otherFee"
                  @input="otherFeeInput"
                  :options="[
                      {id: 'CNY', text: 'CNY'},
                      {id: 'USD', text: 'USD'}
                  ]"
                  :width="['85px', '100%']"
                ></gj-select-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="分摊方式"
                prop="shareMethod"
                :label-width="label1Width">
                <gj-select
                  :options="[
                    {id: 'amount', text: '按金额'},
                    {id: 'quantity', text: '按数量'}
                  ]"
                  v-model="form.shareMethod"
                  :clearable="false"
                ></gj-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item
                label="备注"
                prop="memo">
              <gj-input
                  v-model="form.memo"
                  width="100%"
                  placeholder="备注"
              ></gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
            label="上传附件"
            prop="desc">
          <gj-upload
              upload-btn-type="default"
              container-type="DELIVERY_NOTE"
              :acceptType="[]"
              :fileList.sync="form.files"
              specialUpload
          ></gj-upload>
        </el-form-item>
        <gj-area-title>产品明细</gj-area-title>
        <gj-table
            :index="false"
            :loading="loading"
            name="createDeliveryOrder"
            :data="form.items"
            :columns="columns"
            :show-overflow="false"
            :adapt-height="false"
            :structure-config="{type: 'ParentChild', children: 'products', parentSpan: [0, 8]}">
          <template v-slot:picture="{row}">
            <template v-if="row.$gjParentData">
              <div v-gutter="20">
                <span>{{row.code | defaultShow}}</span>
                <span>{{row.deliveryWarehouseName | defaultShow}}</span>
                <span>
                  <span style="color: #999">采购量/交货量/入库量：</span>
                  {{row.totalOrderQuantity || 0}} / {{row.totalAlreadyDeliveryQuantity || 0}} / {{row.totalInboundQuantity || 0}}
                  </span>
              </div>
            </template>
            <template v-else>
              <gj-image :src="row.smallImageUrl"></gj-image>
            </template>
          </template>
          <template v-slot:sku="{row}">
            <div>
              <gj-text>{{row.productName | defaultShow}}</gj-text>
            </div>
            <div>{{row.sku | defaultShow}}</div>
            <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
          </template>
          <template v-slot:header:deliveryQuantity>
            <span class="required-icon">*</span>本次交货量
            <gj-link @click="setDeliveryQuantity">一键交完</gj-link>
          </template>
          <template v-slot:deliveryQuantity="{row}">
            <el-form-item
                :prop="`items.${row.$gjParentIndex}.products.${row.$gjChildIndex}.deliveryQuantity`"
                :rules="[
                  { required: true, message: '请输入本次交货量', trigger: ['change'] },
                  $gjReRule(RE.pt0, '请输入整数')
                ]"
                label-width="0px"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[row.$gjParentIndex].products[row.$gjChildIndex].deliveryQuantity"
                  width="120px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:header:actualDeliveryDate>
            <span class="required-icon">*</span>实际交货日期
            <gj-link @click="setRealDeliveryDate">一键设置</gj-link>
          </template>
          <template v-slot:actualDeliveryDate="{row}">
            <el-form-item
                :prop="`items.${row.$gjParentIndex}.products.${row.$gjChildIndex}.actualDeliveryDate`"
                :rules="[
                  { required: true, message: '请选择实际交货日期', trigger: ['change'] },
                ]"
                class="gj-table-item"
                label-width="0px">
              <gj-date-picker
                  v-model="form.items[row.$gjParentIndex].products[row.$gjChildIndex].actualDeliveryDate"
                  :clearable="false"
                  width="120px">
              </gj-date-picker>
            </el-form-item>
          </template>
          <template v-slot:memo="{row}">
            <el-form-item
                :prop="`items.${row.$gjParentIndex}.products.${row.$gjChildIndex}.memo`"
                class="gj-table-item"
                label-width="0px">
              <gj-input
                  v-model="form.items[row.$gjParentIndex].products[row.$gjChildIndex].memo"
                  width="200px"
                  placeholder="备注">
              </gj-input>
            </el-form-item>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formDeleteItemMixin, formRuleMixin, modalMixIn, responseMixin} from "../../../../../../minxins";
  import {ProductEnum} from "../../../../../../utils/options";
  import {createDeliveryOrder} from "../../../../../../api/purchase";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {PurchaseOrderEnum} from "../../enum";

  export default {
    name: "app-create-delivery-order-modal",
    mixins: [modalMixIn, formRuleMixin, formDeleteItemMixin, responseMixin],
    props: {
      purchaseOrders: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        loading: false,
        columns: [
          {id: 'picture', header: '图片', field: 'slot:picture', width: '60px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px'},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', width: '70px', align: 'right'},
          {id: 'orderQuantity', header: '采购量', field: 'orderQuantity', width: '70px', align: 'right'},
          {id: 'alreadyDeliveryQuantity', header: '已交量', field: 'alreadyDeliveryQuantity', width: '70px', align: 'right'},
          {id: 'noDeliveryQuantity', header: '未交量', field: 'noDeliveryQuantity', width: '70px', align: 'right'},
          {id: 'deliveryQuantity', header: 'slot:deliveryQuantity', field: 'slot:deliveryQuantity', width: '160px'},
          {id: 'actualDeliveryDate', header: 'slot:actualDeliveryDate', field: 'slot:actualDeliveryDate', width: '160px'},
          {id: 'memo', header: '备注', field: 'slot:memo', width: '220px'},
        ],
        form: {
          memo: null,
          files: [],
          items: [],
          transportFee: {
            key: "CNY",
            value: ""
          },
          otherFee: {
            key: "CNY",
            value: ""
          },
          shareMethod: "amount",
        },
        productTypeOption: ProductEnum.typeOption,
        PurchaseOrderEnum: PurchaseOrderEnum,
        labelWidth: '90px',
        label1Width: '90px',
      }
    },
    created() {
      this.form.items = this.purchaseOrders.map(item => ({
        ...item,
        products: item.products.map(childItem => ({
          ...childItem,
          deliveryQuantity: null,
          actualDeliveryDate: null,
          memo: null
        }))
      }));
    },
    methods: {
      // 其他费用改变
      otherFeeInput() {
        this.form.transportFee.key = this.form.otherFee.key
      },
      // 运费改变
      transportFeeInput() {
        this.form.otherFee.key = this.form.transportFee.key
      },
      setDeliveryQuantity() {
        this.form.items.forEach(item => {
          item.products.forEach(product => {
            this.$set(product, 'deliveryQuantity', Number(product.orderQuantity) - Number(product.alreadyDeliveryQuantity));
          });
        });
      },
      setRealDeliveryDate() {
        const modal = this.$gjCreate('gj-date-picker-modal', {
          on: {
            submit: (date) => {
              this.form.items.forEach(item => {
                item.products.forEach(product => {
                  this.$set(product, 'actualDeliveryDate', date);
                });
              });
              modal.$gjDestroy();
            }
          }
        });
      },
      confirm() {
        if (this.$gjFormValidate()) {
          const params = {
            meme: this.form.memo,
            fileIdList: this.form.files.map(item => item.attId),
            opdtoList: this.form.items.map(item => ({
              id: item.id,
              otherFee: this.form.otherFee.value,
              feeCurrency: this.form.otherFee.key,
              shareMethod: this.form.shareMethod,
              transportFee: this.form.transportFee.value,
              products: item.products.map(product => ({
                id: product.id,
                actualDeliveryDate: convertToDate(product.actualDeliveryDate),
                deliveryQuantity: product.deliveryQuantity,
                memo: product.memo
              }))
            }))
          };
          this.confirmLoading = true;
          createDeliveryOrder(params)
            .then(res => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success(`创建交货单：${res.data}`);
                this.$emit('created');
                this.$gjDestroy();
              });
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    },
  }
</script>

<style scoped>

</style>
